var pug = require("!../../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-side-bar\" ng-class=\"{ visible: $ctrl.visible }\"\u003E\u003Cdiv class=\"side-bar-overlay\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"side-bar-content\" ng-transclude db-stop-propagation=\"click\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/component/calendar-side-bar/calendar-side-bar.tpl.pug
// module id = iphP
// module chunks = 0